export const getAdaptedKeyValue = (currentKey) => {
    return currentKey < 10 ? currentKey * 2 : currentKey >= 10 && currentKey <= 20 ? currentKey + 6 : currentKey;
};

// In order to control the distance between the ticks, it was necessary to
// transform the data as well to align with the ticks.
export const adaptDataForTicks = (chartData) => {
    return chartData.reduce((acc, dataObj) => {
        const adaptedDataPoints = dataObj.data?.map(([key, value]) => {
            const newKey = getAdaptedKeyValue(key);
            return [newKey, value];
        });
        return [...acc, { ...dataObj, data: adaptedDataPoints }];
    }, []);
};
